import React from 'react';
import { Shield, Lock, Award, Users } from 'lucide-react';
import { motion } from 'framer-motion';

export const TrustBadges: React.FC = () => {
  const badges = [
    {
      icon: Shield,
      text: "Pago Seguro",
      subtext: "SSL 256-bit"
    },
    {
      icon: Lock,
      text: "Datos Protegidos",
      subtext: "GDPR Compliant"
    },
    {
      icon: Award,
      text: "Certificado",
      subtext: "ISO 27001"
    },
    {
      icon: Users,
      text: "1000+ Clientes",
      subtext: "Satisfechos"
    }
  ];

  return (
    <div className="grid grid-cols-2 sm:grid-cols-4 gap-3 py-4">
      {badges.map((badge, index) => (
        <motion.div
          key={index}
          className="flex flex-col items-center p-3 bg-background/50 backdrop-blur-sm rounded-lg border border-muted/50"
          initial={{ opacity: 0, y: 10 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ delay: index * 0.1 }}
          whileHover={{ scale: 1.02, y: -2 }}
        >
          <badge.icon className="h-5 w-5 text-green-600 mb-1" />
          <span className="text-xs font-medium text-center leading-tight">
            {badge.text}
          </span>
          <span className="text-[10px] text-muted-foreground text-center">
            {badge.subtext}
          </span>
        </motion.div>
      ))}
    </div>
  );
};